export default () => {
  const kicks = [0, 1, 2, 0, 0];

  return kicks.map((kick, idx) => ({
    kick: kick,
    idx: idx
  }));
};
